import { render, staticRenderFns } from "./resetTradeDc.vue?vue&type=template&id=bf427fa0&scoped=true"
import script from "./resetTradeDc.vue?vue&type=script&lang=js"
export * from "./resetTradeDc.vue?vue&type=script&lang=js"
import style0 from "./resetTradeDc.vue?vue&type=style&index=0&id=bf427fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf427fa0",
  null
  
)

export default component.exports